import { SubTab } from '@hb/shared'
import { useCallback } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { DesktopTabs } from './DesktopTabs'

export const AssessmentDesktopTabs = ({
  tabs,
  mobileLayout,
}: {
  tabs: Array<SubTab>
  mobileLayout: boolean
}) => {
  const { goTo: onTabSelect, selectedAssessment } = useProfile()
  const handleSelect = useCallback(
    (updated: string) => {
      const id = selectedAssessment.id
      if (id) onTabSelect({ entity: { type: 'pregnancy', id }, tab: updated })
    },
    [onTabSelect, selectedAssessment],
  )

  return <DesktopTabs tabs={tabs} mobileLayout={mobileLayout} handleSelect={handleSelect} />
}
